import Swiper from 'Swiper'

/**
 * Hero component
 * @author Dayne Coulson-Hoffacker
 */
export default class Hero {
  /**
   * Constructs a new Hero
   * @param {Object} options - Options object.
   * @param {HMTLElement} options.element - Container element.
   */
  constructor (options) {
    this.element = options.element
    this.swiperContainer = this.element.querySelector('.swiper-container')
    let progressIndicator = this.element.querySelector('.progress__value')

    // Initialize a new swiper instance with options
    const swiper = new Swiper(this.swiperContainer, {
      effect: 'fade',
      autoplay: 7000,
      loop: true,
      autoplayDisableOnInteraction: false,
      onTransitionStart: function(swiper) {
        progressIndicator.style.animation = ''
      },
      onTransitionEnd: function(swiper) {
        progressIndicator.style.animation = 'progress 7s normal'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./components/hero/index.js